import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import { Card, CardBody, Col, Container, Input, Modal, ModalBody, ModalFooter, ModalHeader, Label, Row, Spinner } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import QRcode from 'qrcode.react'
import { jsPDF } from 'jspdf'

const columns = [
    {
        label: 'Código',
        field: 'codigo',
        sort: 'asc'
    },
    {
        label: 'Nombre',
        field: 'nombre',
        sort: 'asc'
    },
    {
        label: 'Marca',
        field: 'marca',
        sort: 'asc'
    },
    {
        label: 'Serie',
        field: 'serie',
        sort: 'asc'
    },
    {
        label: 'Descripción',
        field: 'descripcion',
        sort: 'asc'
    },
    {
        label: 'Cuenta Contable',
        field: 'tipo_cuenta_contable',
        sort: 'asc'
    },
    {
        label: 'Costo',
        field: 'costo',
        sort: 'asc'
    },
    /*{
        label: 'Fecha de Creación',
        field: 'fecha_creacion_str',
        sort: 'asc'
    },*/
    {
        label: 'Estado',
        field: 'estado_nombre',
        sort: 'asc'
    },
    {
        label: 'Control',
        field: 'control_checkbox',
        width: 60
    },
    {
        label: "Acciones",
        field: "handle",
        width: 100
    }
];

export default class ArticuloListado extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);
        this.dataTableRef = React.createRef();

        this.state = {
            tabla: { columns: columns, rows: [] },
            articuloDeBaja: {},
            articuloQR: {},
            modalAbierto: false,
            modalQRAbierto: false,
            mostrarSpinner: true,
            paginacionDatos: {
                paginaActual: null,
                paginaSiguiente: null,
                paginaAnterior: null
            },
            pagina: 1,
            totalPaginas: 0,
            registro: {},
            totalArticulosTabla: 0,
            paginaActualTabla: 1,
            totalPaginasTabla: 1,
            inputPagina: '',
            modalImportarAbierto: false,
            archivoCatalogo: null,
            previewDatos: null,
            importarCargando: false,
            aplicarCargando: false,
            fileInputKey: 0,
            modalCrearAbierto: false,
            archivoPlantilla: null,
            previewCrearDatos: null,
            crearCargando: false,
            aplicarCrearCargando: false,
            fileCrearInputKey: 0,
        }
    }

    componentDidMount() {
        this.cargarListado();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.totalArticulosTabla !== this.state.totalArticulosTabla) {
            const dt = this.dataTableRef.current;
            if (dt && dt.pagesAmount) {
                this.setState({ paginaActualTabla: 1, totalPaginasTabla: dt.pagesAmount() });
            }
        }
    }

    onPaginaCambia = ({ activePage }) => {
        const dt = this.dataTableRef.current;
        const total = dt && dt.pagesAmount ? dt.pagesAmount() : this.state.totalPaginasTabla;
        this.setState({ paginaActualTabla: activePage, totalPaginasTabla: total });
    }

    irAPrimeraPagina = () => {
        const dt = this.dataTableRef.current;
        if (dt && dt.changeActivePage) dt.changeActivePage(0);
    }

    irAUltimaPagina = () => {
        const dt = this.dataTableRef.current;
        if (dt && dt.changeActivePage && dt.pagesAmount) {
            dt.changeActivePage(dt.pagesAmount() - 1);
        }
    }

    irAPagina = () => {
        const pagina = parseInt(this.state.inputPagina, 10);
        if (isNaN(pagina)) return;
        const dt = this.dataTableRef.current;
        if (!dt || !dt.changeActivePage || !dt.pagesAmount) return;
        const total = dt.pagesAmount();
        const destino = Math.max(1, Math.min(pagina, total));
        dt.changeActivePage(destino - 1);
        this.setState({ inputPagina: '' });
    }

    editarRegistro = registro => {
        if(this.apiRest.tienePermiso('item_articulos_editar')){
            this.props.history.replace({ pathname: '/articuloFormulario', registro: registro });
        } else {
            toastr.error('No tiene permiso para editar articulos.');
        }
        
    }

    eliminarRegistro = () => {
        let articuloDeBaja = this.state.articuloDeBaja;
        articuloDeBaja.id = this.state.registro.id;

        this.apiRest.post('/articuloDeBaja', articuloDeBaja).then(resultado => {
            if (resultado.exitoso) {
                if (resultado.data.articuloAsociado) {
                    toastr.error('El articulo esta actualmente asignado, desasigne el articulo antes de darlo de baja.');
                } else {
                    toastr.success('Registro dado de baja exitosamente!');
                    this.ocultarModalEliminar();
                    this.cargarListado();
                }
            }
        });
    }

    cargarListado = () => {
        this.setState({ mostrarSpinner: true });
        //if (this.apiRest.getRol()) {
            //this.articuloPaginacion(this.state.pagina);
            /*if (this.apiRest.getLS('idEmpresa')) {
                this.apiRest.getArticuloEmpresa('/getArticuloEmpresa/').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ tabla: this.agregarAccionesRegistro(respuesta.data), mostrarSpinner: false, totalArticulosTabla: respuesta.data.length });
                    }
                });
            } else {*/
                this.apiRest.get('/articulo').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ tabla: this.agregarAccionesRegistro(respuesta.data), mostrarSpinner: false, totalArticulosTabla: respuesta.data.length });
                    }
                });
            /*}*/
        /*} else {
            if (this.apiRest.getLS('idEmpresa')) {
                this.apiRest.getArticuloEmpresa('/getArticuloEmpresa/').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ tabla: this.agregarAccionesRegistro(respuesta.data), mostrarSpinner: false });
                    }
                });*/
                //this.articuloPaginacionEmpresa(this.state.pagina);
            /*}
        }*/
    }

    articuloPaginacion = (pagina) => {
        this.setState({ mostrarSpinner: true });
        this.apiRest.get('/articuloPagination/' + pagina).then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({
                    pagina: respuesta.data.paginaActual,
                    totalPaginas: respuesta.data.totalPaginas,
                })
                this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data.colaboradorListado) });
            }
        });
    }

    articuloPaginacionEmpresa = (pagina) => {
        this.setState({ mostrarSpinner: true });
        let empresa = this.apiRest.getLS('idEmpresa');
        this.apiRest.put('/articuloPaginacionEmpresa/' + pagina, empresa).then(respuesta => {
            if (respuesta.exitoso) {
                //console.log(respuesta.data);
                this.setState({
                    pagina: respuesta.data.paginaActual,
                    totalPaginas: respuesta.data.totalPaginas,
                })
                this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data.colaboradorListado) });
            }
        });
    }

    paginaSiguiente = () => {
        const {
            pagina,
            totalPaginas
        } = this.state
        let pk = pagina + 1;
        if (pk <= totalPaginas) {
            if (_valid(this.apiRest.getRol())) {
                this.articuloPaginacion(pk);
            } else {
                if (this.apiRest.getLS('idEmpresa')) {
                    this.articuloPaginacionEmpresa(pk);
                }
            }
        }
    }

    paginaAnterior = () => {
        const {
            pagina
        } = this.state
        let id = pagina - 1

        if (id >= 1) {
            if (_valid(this.apiRest.getRol())) {
                this.articuloPaginacion(id);
            } else {
                if (this.apiRest.getLS('idEmpresa')) {
                    this.articuloPaginacionEmpresa(id);
                }
            }
        }
    }

    botonesListado = registro => (
        <div className="btns-fila">
            <MDBBtn className="waves-effect btn-xelapan" size="sm" style={{ background: '#1d4ed8', border: 'none', borderRadius: '5px' }} title="Editar" onClick={() => this.editarRegistro(registro)}>
                <MDBIcon icon="far fa-edit" />
            </MDBBtn>
            {registro.estado > 0
                ? <MDBBtn className="waves-effect btn-xelapan" size="sm" style={{ background: '#dc2626', border: 'none', borderRadius: '5px' }} title="Dar de baja" onClick={() => this.mostrarModalEliminar(registro)}>
                    <MDBIcon icon="fas fa-ban" />
                  </MDBBtn>
                : <span className="badge-baja"><MDBIcon icon="fas fa-ban" /></span>
            }
            <MDBBtn className="waves-effect btn-xelapan" size="sm" style={{ background: '#0891b2', border: 'none', borderRadius: '5px' }} title="Codigo QR" onClick={() => this.mostrarModalQR(registro)}>
                <MDBIcon icon="far fa-qrcode" />
            </MDBBtn>
        </div>
    );

    cambiarControl = (registro, checked) => {
        registro.control = checked;
        this.refrescarCheckboxesControl();
        this.apiRest.put('/articuloControl/' + registro.id, { control: checked }).then(resultado => {
            const guardadoCorrectamente = resultado.exitoso && resultado.data && resultado.data.control === checked;
            if (!guardadoCorrectamente) {
                registro.control = !checked;
                toastr.error('El artículo ' + registro.codigo + ' se marcó en pantalla pero el cambio no se guardó en la base de datos. Se revirtió el checkbox, intente nuevamente.');
                this.refrescarCheckboxesControl();
            }
        });
    }

    refrescarCheckboxesControl = () => {
        const paginaActual = this.state.paginaActualTabla;
        this.setState(estadoAnterior => ({
            tabla: {
                columns: estadoAnterior.tabla.columns,
                rows: estadoAnterior.tabla.rows.map(registro => {
                    registro.control_checkbox = this.checkboxControl(registro);
                    return registro;
                })
            }
        }), () => {
            const dt = this.dataTableRef.current;
            if (dt && dt.changeActivePage) {
                dt.changeActivePage(paginaActual - 1);
            }
        });
    }

    checkboxControl = registro => (
        <Input
            type="checkbox"
            className="form-control"
            style={{ width: '18px', height: '18px', margin: '0 auto' }}
            checked={!!registro.control}
            onChange={e => this.cambiarControl(registro, e.target.checked)}
        />
    );

    botonesQR = registro => (
        <div className="btns-fila">
            <MDBBtn className="waves-effect btn-xelapan" size="sm" style={{ background: '#0891b2', border: 'none', borderRadius: '5px' }} title="Codigo QR" onClick={() => this.mostrarModalQR(registro)}>
                <MDBIcon icon="far fa-qrcode" />
            </MDBBtn>
        </div>
    );

    agregarAccionesRegistro = rows => {
        if(this.apiRest.tienePermiso('item_articulos_editar')){
            rows.forEach(registro => registro.handle = this.botonesListado(registro));
        } else {
            rows.forEach(registro => registro.handle = this.botonesQR(registro));
        }
        rows.forEach(registro => registro.control_checkbox = this.checkboxControl(registro));
        return { columns, rows: rows };
    };

    mostrarModalEliminar = registro => {
        if(this.apiRest.tienePermiso('item_articulos_eliminar')){
            this.setState({ modalAbierto: true, registro: registro, articuloDeBaja: { cantidad_baja: registro.cantidad } });
        } else {
            toastr.error('No tiene permiso para eliminar articulos.');
        }
        
    }

    mostrarModalQR = registro => {
        this.setState({ modalQRAbierto: true, registro: registro, articuloQR: { id: registro.id, codigo: registro.codigo } });
    }

    ocultarModalEliminar = () => {
        this.setState({ modalAbierto: false, registro: {} });
    }

    ocultarModalQR = () => {
        this.setState({ modalQRAbierto: false, registro: {} });
    }

    setValuesDeBaja = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            articuloDeBaja: { ...estadoAnterior.articuloDeBaja, [name]: value }
        }));
    }

    setValuesQR = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            articuloQR: { ...estadoAnterior.articuloQR, [name]: value }
        }));
    }

    generatePDF = async () => {

        let pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: [50, 50]
        })

        // Transforms the canvas into a base64 image
        let base64Image = document.getElementById('qrcode').toDataURL()

        // Adds the image to the pdf
        pdf.addImage(base64Image, 'png', 2, 0, 45, 45)
        pdf.setFontSize(8)
        pdf.text(5, 46, this.state.articuloQR.codigo)
        pdf.autoPrint()
        pdf.output('dataurlnewwindow')
    }

    descargarCatalogo = () => {
        const auth = this.apiRest.getLS('authUser');
        if (!auth) { this.props.history.push('/Timeout'); return; }
        toastr.info('Generando catálogo, espere un momento...');
        fetch(process.env.REACT_APP_API_URL + '/articuloDescargarCatalogo', {
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + auth.access }
        })
        .then(resp => {
            if (!resp.ok) {
                resp.text().then(txt => {
                    console.error('Error descarga catálogo:', txt);
                    toastr.error('Error ' + resp.status + ' al generar el catálogo. Revise la consola del servidor.');
                });
                return null;
            }
            return resp.blob();
        })
        .then(blob => {
            if (!blob) return;
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = 'Catalogo_Articulos.xlsx';
            document.body.appendChild(a);
            a.click();
            setTimeout(() => { window.URL.revokeObjectURL(url); document.body.removeChild(a); }, 200);
        })
        .catch(err => { console.error(err); toastr.error('Error de red al descargar el catálogo.'); });
    }

    mostrarModalImportar = () => {
        this.setState({ modalImportarAbierto: true, archivoCatalogo: null, previewDatos: null, fileInputKey: this.state.fileInputKey + 1 });
    }

    ocultarModalImportar = () => {
        this.setState({ modalImportarAbierto: false, archivoCatalogo: null, previewDatos: null, importarCargando: false, aplicarCargando: false });
    }

    onArchivoChange = (e) => {
        this.setState({ archivoCatalogo: e.target.files[0] || null, previewDatos: null });
    }

    vistaPrevia = () => {
        if (!this.state.archivoCatalogo) { toastr.warning('Seleccione un archivo Excel primero.'); return; }
        const auth = this.apiRest.getLS('authUser');
        if (!auth) { this.props.history.push('/Timeout'); return; }
        this.setState({ importarCargando: true, previewDatos: null });
        const formData = new FormData();
        formData.append('archivo', this.state.archivoCatalogo);
        fetch(process.env.REACT_APP_API_URL + '/articuloPreviewExcel', {
            method: 'POST',
            headers: { 'Authorization': 'Bearer ' + auth.access },
            body: formData
        })
        .then(resp => resp.json())
        .then(data => this.setState({ importarCargando: false, previewDatos: data }))
        .catch(() => { this.setState({ importarCargando: false }); toastr.error('Error al procesar el archivo.'); });
    }

    aplicarCambios = () => {
        const { previewDatos } = this.state;
        if (!previewDatos || !previewDatos.cambios || !previewDatos.cambios.length) return;
        this.setState({ aplicarCargando: true });
        this.apiRest.post('/articuloAplicarExcel', { cambios: previewDatos.cambios }).then(resultado => {
            this.setState({ aplicarCargando: false });
            if (resultado.exitoso) {
                toastr.success(resultado.data.mensaje);
                this.ocultarModalImportar();
                this.cargarListado();
            } else {
                toastr.error((resultado.data && resultado.data.mensaje) ? resultado.data.mensaje : 'Error al aplicar los cambios.');
            }
        });
    }

    descargarPlantillaCreacion = () => {
        const auth = this.apiRest.getLS('authUser');
        if (!auth) { this.props.history.push('/Timeout'); return; }
        toastr.info('Generando plantilla, espere un momento...');
        fetch(process.env.REACT_APP_API_URL + '/articuloDescargarPlantillaCreacion', {
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + auth.access }
        })
        .then(resp => {
            if (!resp.ok) {
                resp.text().then(txt => { console.error('Error descarga plantilla:', txt); toastr.error('Error al generar la plantilla.'); });
                return null;
            }
            return resp.blob();
        })
        .then(blob => {
            if (!blob) return;
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = 'Plantilla_Creacion_Articulos.xlsx';
            document.body.appendChild(a);
            a.click();
            setTimeout(() => { window.URL.revokeObjectURL(url); document.body.removeChild(a); }, 200);
        })
        .catch(err => { console.error(err); toastr.error('Error de red al descargar la plantilla.'); });
    }

    mostrarModalCrear = () => {
        this.setState({ modalCrearAbierto: true, archivoPlantilla: null, previewCrearDatos: null, fileCrearInputKey: this.state.fileCrearInputKey + 1 });
    }

    ocultarModalCrear = () => {
        this.setState({ modalCrearAbierto: false, archivoPlantilla: null, previewCrearDatos: null, crearCargando: false, aplicarCrearCargando: false });
    }

    onArchivoCrearChange = (e) => {
        this.setState({ archivoPlantilla: e.target.files[0] || null, previewCrearDatos: null });
    }

    vistaPreviaCrear = () => {
        if (!this.state.archivoPlantilla) { toastr.warning('Seleccione un archivo Excel primero.'); return; }
        const auth = this.apiRest.getLS('authUser');
        if (!auth) { this.props.history.push('/Timeout'); return; }
        this.setState({ crearCargando: true, previewCrearDatos: null });
        const formData = new FormData();
        formData.append('archivo', this.state.archivoPlantilla);
        fetch(process.env.REACT_APP_API_URL + '/articuloPreviewCreacionExcel', {
            method: 'POST',
            headers: { 'Authorization': 'Bearer ' + auth.access },
            body: formData
        })
        .then(resp => resp.json())
        .then(data => this.setState({ crearCargando: false, previewCrearDatos: data }))
        .catch(() => { this.setState({ crearCargando: false }); toastr.error('Error al procesar el archivo.'); });
    }

    aplicarCreacion = () => {
        const { previewCrearDatos } = this.state;
        if (!previewCrearDatos || !previewCrearDatos.nuevos || !previewCrearDatos.nuevos.length) return;
        this.setState({ aplicarCrearCargando: true });
        this.apiRest.post('/articuloAplicarCreacionExcel', { nuevos: previewCrearDatos.nuevos }).then(resultado => {
            this.setState({ aplicarCrearCargando: false });
            if (resultado.exitoso) {
                toastr.success(resultado.data.mensaje);
                this.ocultarModalCrear();
                this.cargarListado();
            } else {
                toastr.error((resultado.data && resultado.data.mensaje) ? resultado.data.mensaje : 'Error al crear los artículos.');
            }
        });
    }

    render() {
        const {
            registro, articuloDeBaja, articuloQR,
            previewDatos, modalImportarAbierto, importarCargando, aplicarCargando, fileInputKey,
            previewCrearDatos, modalCrearAbierto, crearCargando, aplicarCrearCargando, fileCrearInputKey,
        } = this.state;
        /* ── Paleta: blanco + café sólo como acento de marca ──────────────── */
        const P = { blue:'#1d4ed8', green:'#15803d', amber:'#b45309', violet:'#6d28d9', red:'#dc2626', cyan:'#0891b2', slate:'#475569', gray:'#6b7280', brand:'#392427' };
        const btnBase   = { border: 'none', borderRadius: '6px', fontWeight: '600', letterSpacing: '0.3px' };
        const btnNuevo  = { ...btnBase, background: P.blue };
        const btnExcel  = { ...btnBase, background: P.green };
        const btnUpdate = { ...btnBase, background: P.amber };
        const btnCreate = { ...btnBase, background: P.violet };
        const btnPreview = { ...btnBase, background: P.slate };
        const btnApply  = { ...btnBase, background: P.green };
        const btnCancel = { ...btnBase, background: P.gray };
        const cardStat = (color, icon, value, label) => (
            <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderLeft: `4px solid ${color}`, borderRadius: '8px', padding: '14px 18px', boxShadow: '0 2px 5px rgba(0,0,0,0.06)', display: 'flex', alignItems: 'center', gap: '14px' }}>
                <div style={{ width: '42px', height: '42px', borderRadius: '50%', background: color, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <i className={`fas fa-${icon}`} style={{ color: '#fff', fontSize: '1rem' }} />
                </div>
                <div>
                    <div style={{ fontSize: '1.6rem', fontWeight: '700', lineHeight: 1, color: '#1e293b' }}>{value}</div>
                    <div style={{ fontSize: '0.78rem', color: '#94a3b8', marginTop: '2px' }}>{label}</div>
                </div>
            </div>
        );

        return (
            <React.Fragment>
                <style>{`
                    .btn-xelapan { color: #fff !important; }
                    .btn-xelapan:hover, .btn-xelapan:focus, .btn-xelapan:active { color: #fff !important; filter: brightness(0.88); }
                    .tabla-art .dataTables_wrapper thead th {
                        background-color: #1e293b !important;
                        color: #fff !important;
                        font-weight: 600;
                        letter-spacing: 0.3px;
                    }
                    .tabla-art .dataTables_wrapper thead th::after,
                    .tabla-art .dataTables_wrapper thead th::before { color: rgba(255,255,255,0.5) !important; }
                    .tabla-art .dataTables_wrapper thead th { padding: 12px 14px !important; }
                    .tabla-art .dataTables_wrapper tbody td { padding: 11px 14px !important; vertical-align: middle !important; line-height: 1.45; }
                    .tabla-art .dataTables_wrapper tbody tr { transition: background-color 0.12s; }
                    .tabla-art .dataTables_wrapper tbody tr:hover td { background-color: #f8fafc !important; }
                    .tabla-art .dataTables_wrapper tbody tr:nth-child(even) td { background-color: #fafafa; }
                    .btns-fila { display: inline-flex; align-items: center; gap: 5px; }
                    .badge-baja { display: inline-flex; align-items: center; gap: 4px; background: #f1f5f9; color: #94a3b8; border: 1px solid #e2e8f0; border-radius: 5px; padding: 3px 8px; font-size: 0.72rem; font-weight: 600; letter-spacing: 0.3px; white-space: nowrap; }
                    .pag-nav-bar { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px; padding: 10px 4px 6px; border-top: 1px solid #e8edf2; margin-top: 4px; }
                    .pag-nav-bar .btn-pag { display: inline-flex; align-items: center; gap: 5px; padding: 5px 12px; font-size: 0.8rem; font-weight: 600; color: #fff !important; background: #475569; border: none; border-radius: 6px; cursor: pointer; transition: filter 0.15s; }
                    .pag-nav-bar .btn-pag:hover { filter: brightness(0.88); }
                    .pag-nav-bar .pag-info { font-size: 0.84rem; color: #555; }
                    .pag-nav-bar .pag-total { font-size: 0.8rem; color: #94a3b8; }
                    .modal-hdr-update { background: #fff !important; border-bottom: 3px solid #b45309 !important; }
                    .modal-hdr-update .modal-title, .modal-hdr-update h5 { color: #392427 !important; font-weight: 600; }
                    .modal-hdr-update .close, .modal-hdr-update button.close { color: #555 !important; }
                    .modal-hdr-create { background: #fff !important; border-bottom: 3px solid #6d28d9 !important; }
                    .modal-hdr-create .modal-title, .modal-hdr-create h5 { color: #392427 !important; font-weight: 600; }
                    .modal-hdr-create .close, .modal-hdr-create button.close { color: #555 !important; }
                    .thead-update th { background-color: #b45309 !important; color: #fff !important; }
                    .thead-create th { background-color: #6d28d9 !important; color: #fff !important; }
                `}</style>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Listado" breadcrumbItem="Articulos" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    {
                                        _valid(this.apiRest.getEmpresaNombre()) ?
                                            <Label htmlFor="#" className="form-label">
                                                {'Empresa: ' + this.apiRest.getEmpresaNombre()}
                                            </Label> : ''
                                    }
                                    <CardBody>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center', marginBottom: '16px' }}>
                                            {this.apiRest.tienePermiso('item_articulos_agregar') &&
                                                <MDBBtn className="waves-effect btn-xelapan" style={btnNuevo} onClick={() => this.props.history.replace('/articuloFormulario')}>
                                                    <MDBIcon icon="fas fa-plus" />{' '}Nuevo Art&iacute;culo
                                                </MDBBtn>
                                            }
                                            {this.apiRest.tienePermiso('item_articulos_editar') &&
                                                <React.Fragment>
                                                    <MDBBtn className="waves-effect btn-xelapan" style={btnExcel} onClick={this.descargarCatalogo}>
                                                        <MDBIcon icon="fas fa-file-excel" />{' '}Descargar Cat&aacute;logo
                                                    </MDBBtn>
                                                    <MDBBtn className="waves-effect btn-xelapan" style={btnUpdate} onClick={this.mostrarModalImportar}>
                                                        <MDBIcon icon="fas fa-pen-square" />{' '}Actualizaci&oacute;n Masiva
                                                    </MDBBtn>
                                                    <MDBBtn className="waves-effect btn-xelapan" style={btnCreate} onClick={this.mostrarModalCrear}>
                                                        <MDBIcon icon="fas fa-layer-group" />{' '}Creaci&oacute;n Masiva
                                                    </MDBBtn>
                                                </React.Fragment>
                                            }
                                        </div>

                                        {this.state.mostrarSpinner &&
                                            <Row>
                                                <Col style={{ display: "flex", justifyContent: "center" }}>
                                                    <Spinner className="m-1" color="primary" />
                                                </Col>
                                            </Row>
                                        }
                                        <div className="table-responsive tabla-art">
                                            <MDBDataTable ref={this.dataTableRef} onPageChange={this.onPaginaCambia} striped hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla} />
                                            {this.state.totalArticulosTabla > 0 && (
                                                <div className="pag-nav-bar">
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                        <button className="btn-pag" onClick={this.irAPrimeraPagina} title="Primera página">
                                                            <i className="fas fa-angle-double-left" /> Primera
                                                        </button>
                                                        <span className="pag-info">
                                                            Página <strong>{this.state.paginaActualTabla}</strong> de <strong>{this.state.totalPaginasTabla}</strong>
                                                        </span>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                max={this.state.totalPaginasTabla}
                                                                placeholder="Ir a..."
                                                                value={this.state.inputPagina}
                                                                onChange={e => this.setState({ inputPagina: e.target.value })}
                                                                onKeyDown={e => e.key === 'Enter' && this.irAPagina()}
                                                                style={{ width: '72px', padding: '4px 7px', fontSize: '0.8rem', border: '1px solid #cbd5e1', borderRadius: '6px', textAlign: 'center', outline: 'none' }}
                                                            />
                                                            <button className="btn-pag" onClick={this.irAPagina} title="Ir a página">
                                                                <i className="fas fa-arrow-right" />
                                                            </button>
                                                        </div>
                                                        <button className="btn-pag" onClick={this.irAUltimaPagina} title="Última página">
                                                            Última <i className="fas fa-angle-double-right" />
                                                        </button>
                                                    </div>
                                                    <span className="pag-total">
                                                        <i className="fas fa-cubes" style={{ marginRight: '5px', color: '#cbd5e1' }} />
                                                        Total: <strong>{this.state.totalArticulosTabla.toLocaleString()}</strong> artículos
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* MODAL */}
                <Modal isOpen={this.state.modalAbierto} size="mm">
                    <ModalHeader>
                        Dar de Baja {registro.nombre}
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="razon_baja" className="form-label">
                                        Raz&oacute;n
                                    </Label>
                                    <select
                                        name="razon_baja"
                                        onChange={this.setValuesDeBaja}
                                        type="select"
                                        className="form-control">
                                        <option value="">Seleccionar</option>
                                        <option value="1">Traslado</option>
                                        <option value="2">Inservible</option>
                                        <option value="3">Destruido</option>
                                        <option value="4">Otro</option>
                                    </select>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="cantidad_baja" className="form-label">
                                        Cantidad Actual:
                                    </Label>
                                    <Input
                                        name="cantidad_baja"
                                        value={registro.cantidad}
                                        onChange={this.setValuesDeBaja}
                                        min="0"
                                        type="number"
                                        className="form-control"
                                        disabled="disabled"
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="cantidad_baja" className="form-label">
                                        Cantidad de Baja:
                                    </Label>
                                    <Input
                                        name="cantidad_baja"
                                        value={articuloDeBaja.cantidad_baja}
                                        onChange={this.setValuesDeBaja}
                                        min="0"
                                        type="number"
                                        className="form-control"
                                        placeholder="Ingresa la cantidad de baja"
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="descripcion_baja" className="form-label">
                                        Descripci&oacute;n de Baja
                                    </Label>
                                    <Input
                                        name="descripcion_baja"
                                        value={articuloDeBaja.descripcion_baja}
                                        onChange={this.setValuesDeBaja}
                                        type="text"
                                        maxLength="250"
                                        className="form-control"
                                        placeholder="Ingresa la descripción de baja" />
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter className="text-center" style={{ gap: '8px' }}>
                        <MDBBtn className="waves-effect btn-xelapan" style={{ ...btnBase, background: '#c0392b' }} onClick={() => this.eliminarRegistro()}>
                            <MDBIcon icon="fas fa-trash" />{' '}Dar de Baja
                        </MDBBtn>
                        <MDBBtn className="waves-effect btn-xelapan" style={btnCancel} onClick={() => this.ocultarModalEliminar()}>
                            <MDBIcon icon="fas fa-times" />{' '}Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalQRAbierto} size="mm">
                    <ModalHeader>
                        C&oacute;digo QR {registro.nombre}
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col sm={12}>
                                <div id="articulo_qr">
                                    <QRcode 
                                        value = {'http://soporte.siesa.biz/articuloDetalles/'+articuloQR.id} 
                                        id = 'qrcode'
                                        size = {256}
                                        bgColor = {'#ffffff'}
                                        fgColor = {'#000000'}
                                        level = {'H'}
                                        includeMargin = {true}
                                        name = {articuloQR.id}
                                    />
                                    
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="codigo" className="form-label">
                                        Código
                                    </Label>
                                    <Input
                                        value={this.state.articuloQR.codigo}
                                        name="codigo"
                                        type="text"
                                        className="form-control"
                                        placeholder="---"
                                        required={true}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter className="text-center" style={{ gap: '8px' }}>
                        <MDBBtn className="waves-effect btn-xelapan" style={{ ...btnBase, background: P.cyan }} onClick={() => this.generatePDF()}>
                            <MDBIcon icon="fas fa-print" />{' '}Imprimir
                        </MDBBtn>
                        <MDBBtn className="waves-effect btn-xelapan" style={btnCancel} onClick={() => this.ocultarModalQR()}>
                            <MDBIcon icon="fas fa-times" />{' '}Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={modalImportarAbierto} size="xl">
                    <ModalHeader toggle={this.ocultarModalImportar} className="modal-hdr-update">
                        <MDBIcon icon="fas fa-pen-square" />{' '}Actualizaci&oacute;n Masiva de Art&iacute;culos
                    </ModalHeader>
                    <ModalBody>
                        <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderLeft: '4px solid #b45309', borderRadius: '6px', padding: '10px 14px', marginBottom: '18px', fontSize: '0.88rem', color: '#78350f' }}>
                            <strong>Instrucciones:</strong> Descargue el cat&aacute;logo, edite los art&iacute;culos en Excel y suba el archivo para ver una vista previa antes de aplicar.
                            Los campos <strong>ID, Estado, Categor&iacute;as e Im&aacute;genes</strong> no se modifican por este medio.
                        </div>
                        <Row className="mb-3 align-items-end">
                            <Col lg={4} className="mb-2">
                                <MDBBtn className="waves-effect btn-xelapan" style={btnExcel} onClick={this.descargarCatalogo}>
                                    <MDBIcon icon="fas fa-file-excel" />{' '}Descargar Cat&aacute;logo
                                </MDBBtn>
                            </Col>
                            <Col lg={5} className="mb-2">
                                <Label className="form-label fw-semibold" style={{ color: '#555', fontSize: '0.85rem' }}>Seleccionar archivo Excel (.xlsx)</Label>
                                <Input type="file" accept=".xlsx,.xls" className="form-control" onChange={this.onArchivoChange} key={fileInputKey} />
                            </Col>
                            <Col lg={3} className="mb-2">
                                <MDBBtn className="waves-effect btn-xelapan" style={{ ...btnPreview, background: importarCargando || !this.state.archivoCatalogo ? '#aaa' : P.slate }} onClick={this.vistaPrevia} disabled={importarCargando || !this.state.archivoCatalogo}>
                                    {importarCargando
                                        ? <React.Fragment><Spinner size="sm" />{' '}Procesando...</React.Fragment>
                                        : <React.Fragment><MDBIcon icon="fas fa-search" />{' '}Vista Previa</React.Fragment>
                                    }
                                </MDBBtn>
                            </Col>
                        </Row>

                        {previewDatos && (
                            <div>
                                <Row className="mb-3 g-3">
                                    <Col lg={3} sm={6}>{cardStat(P.slate,  'list-ol',       previewDatos.total,           'Total filas')}</Col>
                                    <Col lg={3} sm={6}>{cardStat(P.amber,  'sync-alt',      previewDatos.a_actualizar,    'A actualizar')}</Col>
                                    <Col lg={3} sm={6}>{cardStat(P.green,  'check-double',  previewDatos.sin_cambios,     'Sin cambios')}</Col>
                                    <Col lg={3} sm={6}>{cardStat(previewDatos.errores.length > 0 ? P.red : '#94a3b8', previewDatos.errores.length > 0 ? 'exclamation-circle' : 'check-circle', previewDatos.errores.length, 'Errores')}</Col>
                                </Row>

                                {previewDatos.errores.length > 0 && (
                                    <div style={{ background: '#fdf2f2', border: '1px solid #f5c6c6', borderLeft: '4px solid #e74c3c', borderRadius: '6px', padding: '10px 14px', marginBottom: '12px' }}>
                                        <strong style={{ color: '#c0392b' }}>Se encontraron {previewDatos.errores.length} error(es). Corrija el archivo e intente nuevamente:</strong>
                                        <ul className="mt-2 mb-0" style={{ maxHeight: '180px', overflowY: 'auto', fontSize: '0.85rem', color: '#7b241c' }}>
                                            {previewDatos.errores.map((e, i) => <li key={i}>{e}</li>)}
                                        </ul>
                                    </div>
                                )}

                                {previewDatos.errores.length === 0 && previewDatos.cambios.length === 0 && (
                                    <div style={{ background: '#f0faf4', border: '1px solid #a9dfbf', borderLeft: '4px solid #27ae60', borderRadius: '6px', padding: '10px 14px', color: '#1e8449', fontSize: '0.88rem' }}>
                                        <MDBIcon icon="fas fa-check-circle" />{' '}El archivo no contiene cambios respecto a los datos actuales del sistema.
                                    </div>
                                )}

                                {previewDatos.errores.length === 0 && previewDatos.cambios.length > 0 && (() => {
                                    const LIMITE = 300;
                                    const filas = [];
                                    let totalMods = 0;
                                    let limiteAlcanzado = false;
                                    for (let ci = 0; ci < previewDatos.cambios.length; ci++) {
                                        const cambio = previewDatos.cambios[ci];
                                        if (totalMods >= LIMITE) { limiteAlcanzado = true; break; }
                                        for (let mi = 0; mi < cambio.modificaciones.length; mi++) {
                                            const mod = cambio.modificaciones[mi];
                                            filas.push({ key: cambio.id + '-' + mod.campo, mostrarArticulo: mi === 0, rowSpan: cambio.modificaciones.length, fila: cambio.fila, id: cambio.id, codigo: cambio.codigo, nombre: cambio.nombre, label: mod.label, actual: mod.actual, nuevo: mod.nuevo });
                                            totalMods++;
                                        }
                                    }
                                    return (
                                        <div>
                                            <div style={{ fontWeight: '600', color: '#c0392b', marginBottom: '8px', fontSize: '0.9rem' }}>
                                                <MDBIcon icon="fas fa-table" />{' '}{previewDatos.a_actualizar} art&iacute;culo(s) con cambios detectados:
                                            </div>
                                            {limiteAlcanzado && (
                                                <div style={{ background: '#fefde7', border: '1px solid #f9e79f', borderLeft: '4px solid #f39c12', borderRadius: '6px', padding: '8px 12px', marginBottom: '8px', fontSize: '0.82rem', color: '#7d6608' }}>
                                                    Mostrando los primeros {LIMITE} cambios. El resto se aplicar&aacute; correctamente al confirmar.
                                                </div>
                                            )}
                                            <div style={{ maxHeight: '400px', overflowY: 'auto', fontSize: '0.83rem', borderRadius: '6px', border: '1px solid #e0e0e0' }}>
                                                <table className="table table-bordered table-sm mb-0">
                                                    <thead className="thead-update">
                                                        <tr>
                                                            <th>Fila</th><th>ID</th><th>C&oacute;digo</th><th>Nombre</th><th>Campo</th>
                                                            <th>Valor Actual</th><th>Valor Nuevo</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filas.map(f => (
                                                            <tr key={f.key}>
                                                                {f.mostrarArticulo && (
                                                                    <React.Fragment>
                                                                        <td rowSpan={f.rowSpan} className="align-middle" style={{ fontWeight: '500' }}>{f.fila}</td>
                                                                        <td rowSpan={f.rowSpan} className="align-middle">{f.id}</td>
                                                                        <td rowSpan={f.rowSpan} className="align-middle" style={{ fontWeight: '600' }}>{f.codigo}</td>
                                                                        <td rowSpan={f.rowSpan} className="align-middle">{f.nombre}</td>
                                                                    </React.Fragment>
                                                                )}
                                                                <td><strong style={{ color: '#555' }}>{f.label}</strong></td>
                                                                <td style={{ color: '#c0392b', background: '#fdf2f2' }}>{f.actual}</td>
                                                                <td style={{ color: '#1e8449', background: '#f0faf4' }}>{f.nuevo}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    );
                                })()}
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter style={{ borderTop: '1px solid #ede0d8', gap: '8px' }}>
                        {previewDatos && previewDatos.errores.length === 0 && previewDatos.cambios.length > 0 && (
                            <MDBBtn className="waves-effect btn-xelapan" style={btnApply} onClick={this.aplicarCambios} disabled={aplicarCargando}>
                                {aplicarCargando
                                    ? <React.Fragment><Spinner size="sm" />{' '}Aplicando...</React.Fragment>
                                    : <React.Fragment><MDBIcon icon="fas fa-check" />{' '}Aplicar {previewDatos.a_actualizar} cambio(s)</React.Fragment>
                                }
                            </MDBBtn>
                        )}
                        <MDBBtn className="waves-effect btn-xelapan" style={btnCancel} onClick={this.ocultarModalImportar}>
                            <MDBIcon icon="fas fa-times" />{' '}Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>
                {/* MODAL CREACIÓN MASIVA */}
                <Modal isOpen={modalCrearAbierto} size="xl">
                    <ModalHeader toggle={this.ocultarModalCrear} className="modal-hdr-create">
                        <MDBIcon icon="fas fa-layer-group" />{' '}Creaci&oacute;n Masiva de Art&iacute;culos
                    </ModalHeader>
                    <ModalBody>
                        <div style={{ background: '#f5f3ff', border: '1px solid #ddd6fe', borderLeft: '4px solid #6d28d9', borderRadius: '6px', padding: '10px 14px', marginBottom: '18px', fontSize: '0.88rem', color: '#4c1d95' }}>
                            <strong>Instrucciones:</strong> Descargue la plantilla, ll&eacute;nela con los nuevos art&iacute;culos y s&uacute;bala para ver una vista previa antes de crear.
                            Campos obligatorios: <strong>Codigo, Nombre, Tipo y Vendible</strong>. Los art&iacute;culos se crear&aacute;n con estado <em>No Asignado</em>; las categor&iacute;as y empresas se asignan manualmente despu&eacute;s.
                        </div>
                        <Row className="mb-3 align-items-end">
                            <Col lg={4} className="mb-2">
                                <MDBBtn className="waves-effect btn-xelapan" style={btnExcel} onClick={this.descargarPlantillaCreacion}>
                                    <MDBIcon icon="fas fa-file-excel" />{' '}Descargar Plantilla
                                </MDBBtn>
                            </Col>
                            <Col lg={5} className="mb-2">
                                <Label className="form-label fw-semibold" style={{ color: '#555', fontSize: '0.85rem' }}>Seleccionar archivo completado (.xlsx)</Label>
                                <Input type="file" accept=".xlsx,.xls" className="form-control" onChange={this.onArchivoCrearChange} key={fileCrearInputKey} />
                            </Col>
                            <Col lg={3} className="mb-2">
                                <MDBBtn className="waves-effect btn-xelapan" style={{ ...btnPreview, background: crearCargando || !this.state.archivoPlantilla ? '#aaa' : P.slate }} onClick={this.vistaPreviaCrear} disabled={crearCargando || !this.state.archivoPlantilla}>
                                    {crearCargando
                                        ? <React.Fragment><Spinner size="sm" />{' '}Procesando...</React.Fragment>
                                        : <React.Fragment><MDBIcon icon="fas fa-search" />{' '}Vista Previa</React.Fragment>
                                    }
                                </MDBBtn>
                            </Col>
                        </Row>

                        {previewCrearDatos && (
                            <div>
                                <Row className="mb-3 g-3">
                                    <Col lg={4} sm={4}>{cardStat(P.slate,  'list-ol',    previewCrearDatos.total, 'Total filas')}</Col>
                                    <Col lg={4} sm={4}>{cardStat(P.violet, 'plus-circle', previewCrearDatos.nuevos ? previewCrearDatos.nuevos.length : 0, 'A crear')}</Col>
                                    <Col lg={4} sm={4}>{cardStat((previewCrearDatos.errores && previewCrearDatos.errores.length > 0) ? P.red : '#94a3b8', (previewCrearDatos.errores && previewCrearDatos.errores.length > 0) ? 'exclamation-circle' : 'check-circle', previewCrearDatos.errores ? previewCrearDatos.errores.length : 0, 'Errores')}</Col>
                                </Row>

                                {previewCrearDatos.errores && previewCrearDatos.errores.length > 0 && (
                                    <div style={{ background: '#fdf2f2', border: '1px solid #f5c6c6', borderLeft: '4px solid #e74c3c', borderRadius: '6px', padding: '10px 14px', marginBottom: '12px' }}>
                                        <strong style={{ color: '#c0392b' }}>Se encontraron {previewCrearDatos.errores.length} error(es):</strong>
                                        <ul className="mt-2 mb-0" style={{ maxHeight: '180px', overflowY: 'auto', fontSize: '0.85rem', color: '#7b241c' }}>
                                            {previewCrearDatos.errores.map((e, i) => <li key={i}>{e}</li>)}
                                        </ul>
                                    </div>
                                )}

                                {previewCrearDatos.nuevos && previewCrearDatos.nuevos.length > 0 && (
                                    <div>
                                        <div style={{ fontWeight: '600', color: '#1a5276', marginBottom: '8px', fontSize: '0.9rem' }}>
                                            <MDBIcon icon="fas fa-table" />{' '}{previewCrearDatos.nuevos.length} art&iacute;culo(s) listos para crear:
                                        </div>
                                        <div style={{ maxHeight: '380px', overflowY: 'auto', borderRadius: '6px', border: '1px solid #e0e0e0', fontSize: '0.83rem' }}>
                                            <table className="table table-bordered table-sm table-hover mb-0">
                                                <thead className="thead-create">
                                                    <tr>
                                                        <th>Fila</th>
                                                        <th>C&oacute;digo</th>
                                                        <th>Nombre</th>
                                                        <th>Tipo</th>
                                                        <th>Vendible</th>
                                                        <th>Cantidad</th>
                                                        <th>Activo</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {previewCrearDatos.nuevos.map((n, i) => (
                                                        <tr key={i}>
                                                            <td style={{ color: '#888', fontWeight: '500' }}>{n.fila}</td>
                                                            <td style={{ fontWeight: '600' }}>{n.codigo}</td>
                                                            <td>{n.nombre}</td>
                                                            <td><span style={{ background: '#e8f4fd', color: '#1565c0', padding: '1px 7px', borderRadius: '10px', fontSize: '0.8rem', fontWeight: '500' }}>{n.tipo_label}</span></td>
                                                            <td style={{ textAlign: 'center' }}><span style={{ background: n.vendible_label === 'Si' ? '#e8f8f0' : '#fdf2f2', color: n.vendible_label === 'Si' ? '#1e8449' : '#c0392b', padding: '1px 7px', borderRadius: '10px', fontSize: '0.8rem', fontWeight: '500' }}>{n.vendible_label}</span></td>
                                                            <td style={{ textAlign: 'center' }}>{n.cantidad}</td>
                                                            <td style={{ textAlign: 'center' }}><span style={{ background: n.activo_label === 'Si' ? '#e8f8f0' : '#f0f0f0', color: n.activo_label === 'Si' ? '#1e8449' : '#888', padding: '1px 7px', borderRadius: '10px', fontSize: '0.8rem', fontWeight: '500' }}>{n.activo_label}</span></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter style={{ borderTop: '1px solid #ede0d8', gap: '8px' }}>
                        {previewCrearDatos && previewCrearDatos.errores && previewCrearDatos.errores.length === 0 && previewCrearDatos.nuevos && previewCrearDatos.nuevos.length > 0 && (
                            <MDBBtn className="waves-effect btn-xelapan" style={btnApply} onClick={this.aplicarCreacion} disabled={aplicarCrearCargando}>
                                {aplicarCrearCargando
                                    ? <React.Fragment><Spinner size="sm" />{' '}Creando...</React.Fragment>
                                    : <React.Fragment><MDBIcon icon="fas fa-check" />{' '}Crear {previewCrearDatos.nuevos.length} art&iacute;culo(s)</React.Fragment>
                                }
                            </MDBBtn>
                        )}
                        <MDBBtn className="waves-effect btn-xelapan" style={btnCancel} onClick={this.ocultarModalCrear}>
                            <MDBIcon icon="fas fa-times" />{' '}Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>

            </React.Fragment>
        )
    }
}